import { render, staticRenderFns } from "./TemplateDashboard.vue?vue&type=template&id=a1727920&scoped=true"
import script from "./TemplateDashboard.vue?vue&type=script&lang=js"
export * from "./TemplateDashboard.vue?vue&type=script&lang=js"
import style0 from "./TemplateDashboard.vue?vue&type=style&index=0&id=a1727920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1727920",
  null
  
)

export default component.exports